import React from 'react';
// import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { MainView } from '../../templates/MainView';
import { Image } from '../../components/atoms/Image';
import { Heading } from '../../components/atoms/Heading';
import { Text } from '../../components/atoms/Text';
import { Button } from '../../components/atoms/Button';

import './styles.css';

import HelpBlockImage from '../../assets/images/conversation.png';
import { InfoCard } from '../../components/molecules/InfoCard';
import Illustration from '../../components/molecules/Illustration';
import { useSelector } from 'react-redux';

/**
 * Primary UI component for user interaction
 */
function Landing() {
    const navigate = useNavigate();
    const { layout } = useSelector((state) => state.layout);

    const isPopup = layout === 'popup';

    return (
        <MainView type="fullwidth">
            <section className="w-full bg-gray-100 md:py-10">
                <div
                    className={`bg-primary-100 mx-auto md:rounded-xl  ${
                        isPopup ? 'max-w-lwd-758' : 'max-w-lwd-758 lg:w-1/2'
                    } `}>
                    <div className="flex flex-col gap-5 h-auto md:rounded-xl">
                        <Illustration type="landing" classes="w-full object-center rounded-t-xl md:min-h-[106px]" />
                    </div>

                    <div className="flex flex-col gap-2 p-6 md:p-14">
                        <Heading h1>Welcome to the Habit Hacker! I'm Alex, your virtual coach.</Heading>
                        <Text body>
                            The Habit Hacker was designed by our health and psychology experts for people who need a bit
                            of inspiration to improve their lifestyle habits. Answer our 3 short questions to receive a
                            quick tip based on the tried-and-tested techniques our real-life coaches use every day! It’s
                            super quick to complete, and I'll be here to guide you through it.
                        </Text>

                        <div className="grid grid-cols-3 mt-4 gap-4">
                            <InfoCard
                                variant="primary"
                                classes="flex flex-col text-center"
                                icon="circle-star"
                                text="Quick self-help tips written by our experts"
                            />
                            <InfoCard
                                variant="primary"
                                classes="flex flex-col text-center"
                                icon="timer"
                                text="3 short questions - takes 5 minutes"
                            />
                            <InfoCard
                                variant="primary"
                                classes="flex flex-col text-center"
                                icon="secure"
                                text="No account or personal details required"
                            />
                        </div>

                        <Button
                            mode="primary"
                            type="button"
                            label="Get Started"
                            classes="flex items-center justify-center mt-4"
                            onClick={() => navigate('/pathway')}
                        />
                    </div>
                </div>
            </section>
            <section>
                <div
                    className={`py-8 px-6 flex flex-col items-center mx-auto gap-6 md:flex-row-reverse md:gap-8 md:py-18 ${
                        isPopup ? 'max-w-lwd-758 md:px-6' : 'mx-auto max-w-lwd-758 lg:w-1/2 md:px-0'
                    }`}>
                    <div className="h-auto w-full lg:w-1/2 overflow-hidden rounded-md">
                        <Image src={HelpBlockImage} imgClass="rounded-md h-full object-left" video />
                    </div>
                    <div className="flex flex-col gap-3 w-full lg:w-1/2">
                        <Heading h2>Feel like you need more help?</Heading>
                        <Text body>
                            If you think you may need some more hands-on help, maybe you should consider registering
                            with us, where our real-life team are on hand to provide excellent coaching, advice and
                            support! You can register online or give our team of expert advisors a call on 0800 840 1628
                            to get started.
                        </Text>

                        <div>
                            <a
                                href="https://my.livewelldorset.co.uk/register"
                                target="_blank"
                                rel="noreferrer noopener"
                                className="btn w-full mt-2 justify-center md:w-auto bg-white text-primary-500">
                                Speak To An Expert
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </MainView>
    );
}

export default Landing;
